var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "cookie-subscribe" }, [
      !_vm.cookie
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-lg-8 col-md-12 p-0" }, [
                _c("div", { staticClass: "cookie__blck" }, [
                  _c("div", { staticClass: "content" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "close__blck",
                        on: { click: _vm.setCookie }
                      },
                      [
                        _c("button", { staticClass: "close__btn" }, [
                          _vm._v("Jag förstår")
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", { attrs: { src: "/img/cookie.svg", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text" }, [
      _c("p", { staticClass: "min-min" }, [
        _vm._v(
          "Vi använder cookies: vilket hjälper sidan fungera bättre. Genom att fortsätta använda tjänsten godkänner du användandet av cookies. Läs mer: "
        ),
        _c("a", { attrs: { href: "https://tecknael.se" } }, [
          _vm._v("https://tecknael.se")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }